var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { size: "lg", title: "Enter URLs" },
      on: { ok: _vm.ok, shown: _vm.onModalShown, hidden: _vm.onModalHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-ok",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.uploadMethod === "bookmark" ? "Save" : "Upload") +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "urls-container" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "input-label" }, [
              _vm._v("\n          URLs\n          "),
              _c(
                "a",
                {
                  staticClass: "image-compress-max-size-tooltip",
                  staticStyle: { color: "#727272" },
                  attrs: {
                    href: "#",
                    "data-toggle": "tooltip",
                    title: "Upload from URL or save bookmark",
                  },
                },
                [_c("i", { staticClass: "fa fa-info-circle" })]
              ),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.urls,
                  expression: "urls",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "extenal_file_url",
                type: "url",
                name: "extenal_file_url",
                placeholder: "https://...",
                rows: "4",
              },
              domProps: { value: _vm.urls },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.urls = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-1" }, [
            _c("div", { staticClass: "form-group mb-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.uploadMethod,
                    expression: "uploadMethod",
                  },
                ],
                attrs: {
                  id: "upload_from_web",
                  type: "radio",
                  name: "upload_from_web",
                  value: "upload",
                },
                domProps: { checked: _vm._q(_vm.uploadMethod, "upload") },
                on: {
                  change: function ($event) {
                    _vm.uploadMethod = "upload"
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "upload_from_web" } }, [
                _vm._v("Upload from web"),
              ]),
            ]),
            _vm._v(" "),
            !_vm.isProducts
              ? _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.uploadMethod,
                        expression: "uploadMethod",
                      },
                    ],
                    attrs: {
                      id: "just_store_from_web",
                      type: "radio",
                      name: "upload_from_web",
                      value: "bookmark",
                    },
                    domProps: { checked: _vm._q(_vm.uploadMethod, "bookmark") },
                    on: {
                      change: function ($event) {
                        _vm.uploadMethod = "bookmark"
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "just_store_from_web" } }, [
                    _vm._v("Save as bookmark"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }